module.exports = __webpack_public_path__ + "static/login.761efb54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/screenshots/buddybet/login.jpg
// module id = ./src/app/data/screenshots/buddybet/login.jpg
// module chunks = 10